function debounce(e, i = 300) {
  let t;
  return (...n) => {
    clearTimeout(t), t = setTimeout(() => e.apply(this, n), i)
  }
}
if (!customElements.get("announcement-bar")) {
  class e extends HTMLElement {
    constructor() {
      super(), this.slider = this.querySelector(".announcement__slider"), this.localization = this
        .querySelector(".announcement__localization"), this.links = this.querySelectorAll(
          ".js-announcement-link"), this.menu = document.querySelector(".main-menu__content"),
        this.isPaused = !1, this.bindEvents(), this.init()
    }
    disconnectedCallback() {
      this.moveLinksHandler && window.removeEventListener("on:breakpoint-change", this
        .moveLinksHandler), this.moveLocalizationHandler && window.removeEventListener(
        "on:breakpoint-change", this.moveLocalizationHandler)
    }
    bindEvents() {
      this.links && (this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this),
          window.addEventListener("on:breakpoint-change", this.moveLinksHandler)), this
        .localization && (this.moveLocalizationHandler = this.moveLocalizationHandler || debounce(
          this.moveLocalization.bind(this)), window.addEventListener("on:breakpoint-change",
          this.moveLocalizationHandler)), this.slider && (this.slider.addEventListener(
          "mouseenter", this.pauseSlider.bind(this)), this.slider.addEventListener("mouseleave",
          this.resumeSlider.bind(this)))
    }
    init() {
      if (this.slider) {
        let e = this.slider.querySelectorAll(".announcement__text");
        e[0].classList.add("is-visible");
        let i = () => {
          if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
            let t = this.slider.querySelector(".announcement__text.is-visible"),
              n = Array.from(t.parentNode.children).indexOf(t),
              s = n + 1 < e.length ? n + 1 : 0;
            "rtl" === document.dir ? this.slider.scrollTo(-Math.abs(s * e[s].clientWidth), 0) :
              this.slider.scrollTo(e[s].offsetLeft - 32, 0), e[s].classList.add("is-visible"),
              e[n].classList.remove("is-visible")
          }
          setTimeout(i, this.dataset.slideDelay)
        };
        setTimeout(i, this.dataset.slideDelay)
      }
      this.links && this.moveLinks(), this.localization && this.moveLocalization()
    }
    moveLinks() {
      let e = document.querySelector(".mob__announcement-links");
      if (theme.mediaMatches.md || e) theme.mediaMatches.md && e && e.remove();
      else {
        let i = document.createElement("nav");
        i.classList.add("mob__announcement-links");
        let t = document.createElement("ul");
        i.classList.add("secondary-nav"), this.links.forEach(e => {
          i.innerHTML +=
            `<li><a class="secondary-nav__item" href="${e.href}">${e.innerText}</a>`
        }), i.appendChild(t), this.menu.appendChild(i)
      }
    }
    moveLocalization() {
      this.slider = this.querySelector(".announcement__slider"), this.localization = this
        .querySelector(".announcement__localization"), this.links = this.querySelectorAll(
          ".js-announcement-link"), this.menu = document.querySelector(".main-menu__content");
      let e = document.querySelector(".mob__localization");
      if (theme.mediaMatches.md || e) theme.mediaMatches.md && e && (this.localization
        .appendChild(e.firstElementChild), e.remove());
      else {
        let i = document.createElement("div");
        i.classList.add("mob__localization"), i.appendChild(this.localization.firstElementChild),
          this.menu.appendChild(i)
      }
    }
    pauseSlider() {
      this.isPaused = !0
    }
    resumeSlider() {
      this.isPaused = !1
    }
  }
  customElements.define("announcement-bar", e)
}
